var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-pb_5" }, [
    _c("div", { staticClass: "emd-container _highlight_header" }, [
      _c("div", { staticClass: "emd-container__header" }, [
        _c("h2", { staticClass: "emd-text _size_default _type_caption" }, [
          _vm._v(" " + _vm._s(_vm.$t("title")) + ": "),
          _c("span", { staticClass: "emd-text _type_hint" }, [
            _vm._v(_vm._s(_vm.charge.id)),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "eu-flex eu-align-items_center eu-gap_3 eu-no-margin",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "eu-flex eu-align-items_center eu-no-margin eu-gap_3",
              },
              [
                _vm.showCancellationLetter
                  ? _c(
                      "jade-button",
                      {
                        attrs: {
                          variant: "primary-solid",
                          size: "small",
                          icon: "action-download",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getLetter("Cancellation")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("refund-receipt")) + " ")]
                    )
                  : _vm._e(),
                _vm.showRefundButton
                  ? _c(
                      "jade-button",
                      {
                        attrs: {
                          variant: "primary-solid",
                          size: "small",
                          icon: "arrow-forward",
                        },
                        on: { click: _vm.openModalRefund },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("refund")) + " ")]
                    )
                  : _vm._e(),
                _vm.showSimulatorPaymentsButton
                  ? _c(
                      "jade-button",
                      {
                        attrs: {
                          variant: "primary-solid",
                          size: "small",
                          icon: "money-notes",
                        },
                        on: { click: _vm.openModalSimulatorPayments },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("simulator-payments")) + " ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.showDivider
              ? _c(
                  "div",
                  { staticStyle: { height: "36px" } },
                  [_c("jade-divider", { attrs: { direction: "vertical" } })],
                  1
                )
              : _vm._e(),
            _vm.showActionsButton
              ? _c(
                  "div",
                  {
                    staticClass: "emd-dropdown _position_right",
                    attrs: { id: "jsDropdown" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "emd-dropdown__trigger" },
                      [
                        _c(
                          "jade-action-button",
                          {
                            attrs: {
                              variant: "primary-solid",
                              size: "small",
                              icon: "plus",
                              dropdownIndicator: "",
                            },
                            on: { click: _vm.toogleDropdown },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("actions.title")) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "emd-dropdown__content",
                        class: { _active: _vm.showActionsDropdown },
                      },
                      [
                        _c(
                          "nav",
                          {
                            staticClass:
                              "emd-nav-list _direction_column _hoverble",
                          },
                          [
                            _c("ul", [
                              _vm.permissionIsEnabled(
                                "charge.transaction:resync"
                              )
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "emd-nav-list__item",
                                      on: { click: _vm.resync },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "uil uil-redo",
                                          }),
                                          _c(
                                            "jade-text",
                                            {
                                              attrs: { variant: "text-small" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "actions.resync-charge"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.canRetryCharge
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "emd-nav-list__item",
                                      on: { click: _vm.openRetryModal },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "uil uil-refresh",
                                          }),
                                          _c(
                                            "jade-text",
                                            {
                                              attrs: { variant: "text-small" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "actions.retry-charge"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.charge.capture.show &&
                              _vm.componentIsEnabled("charge", "capture") &&
                              _vm.permissionIsEnabled("charge:capture")
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "emd-nav-list__item",
                                      on: { click: _vm.openCaptureModal },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "uil uil-check-circle",
                                          }),
                                          _c(
                                            "jade-text",
                                            {
                                              attrs: { variant: "text-small" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "actions.capture-charge"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.charge.confirm.show &&
                              _vm.componentIsEnabled("charge", "confirm") &&
                              _vm.permissionIsEnabled("charge:confirm")
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "emd-nav-list__item",
                                      on: { click: _vm.openConfirmModal },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "uil uil-check-circle",
                                          }),
                                          _c(
                                            "jade-text",
                                            {
                                              attrs: { variant: "text-small" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "actions.confirm-charge"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.showAttemptButton
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "emd-nav-list__item",
                                      on: { click: _vm.openAttemptModal },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "uil uil-check-circle",
                                          }),
                                          _c(
                                            "jade-text",
                                            {
                                              attrs: { variant: "text-small" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "actions.attempt-charge"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.charge.authorization_letter.show &&
                              _vm.permissionIsEnabled(
                                "charge.letter.authorization:get"
                              )
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "emd-nav-list__item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.getLetter("Authorization")
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "emd-btn _type_link _color_tertiary eu-pa_3 eu-flex eu-align-items_center eu-gap_1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "uil uil-download-alt",
                                          }),
                                          _c(
                                            "jade-text",
                                            {
                                              attrs: { variant: "text-small" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "actions.payment-receipt"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "emd-table-responsive" },
        [
          _c("DashTable", {
            attrs: {
              fields: _vm.fields,
              items: _vm.chargeValues,
              eventProps: _vm.tableEvents,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }